import { render } from "./noticeDetails.vue?vue&type=template&id=50804058&scoped=true"
import script from "./noticeDetails.vue?vue&type=script&lang=js"
export * from "./noticeDetails.vue?vue&type=script&lang=js"

import "./noticeDetails.vue?vue&type=style&index=0&id=50804058&lang=css"
import "./noticeDetails.vue?vue&type=style&index=1&id=50804058&scoped=true&lang=css"

import exportComponent from "D:\\AAA_WORK\\os_FMS_sys_projectop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50804058"]])

export default __exports__